// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_m1p","cls2":"common-cls2_zQQ common-cls1_m1p"};